<template>
  <v-app>
    <!-- Laptop view -->
    <v-main class="hidden-md-and-down">
      <v-row>
        <v-col cols="12" md="1" sm="1" lg="1">
          <NavMenu/>
        </v-col>
        <v-spacer />
        <v-col cols="12" md="10" sm="10" lg="10">
          <v-container>
            <div style="margin:30px 110px 30px 110px">
              <div style="width:100%">
                <span
                  class="font-weight-bold"
                  style="text-align:start;padding-top:3px;text-decoration:none;font-size:24px"
                >
                  Hi
                  {{ person.displayName.substr(0,person.displayName.indexOf(' '))}}
                  👋🏾</span
                >

              <v-menu
      transition="slide-x-transition"
      bottom
    > 
          <template v-slot:activator="{ on, attrs }">
                <v-avatar style="float:right"  v-bind="attrs"
          v-on="on">
                  <img :src="person.photoURL" alt="" />
                </v-avatar>
                </template>
                <v-list>
                <v-list-item>
                <v-list-item-avatar>
                <img :src="person.photoURL" alt="" />
                </v-list-item-avatar>
                <v-list-item-content>{{person.displayName}} <!--.substr(0,user.displayName.indexOf(' '))--></v-list-item-content>
                </v-list-item>
                <v-list-item>
        <v-item-action>
        <v-btn small text :to="`/${username}`">View your page <v-icon small>mdi-arrow-right</v-icon></v-btn>
        </v-item-action>
        </v-list-item>
        <v-list-item
          v-for="(item, i) in menu"
          :key="i"
          :to="item.link"
        >
        <v-list-item-icon><v-icon>{{item.icon}}</v-icon></v-list-item-icon>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
        <v-list-item @click="logOut()">
        <v-list-item-icon><v-icon>mdi-logout</v-icon></v-list-item-icon>
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item>
      </v-list>
      </v-menu>
                <v-badge
                  small
                  overlap
                  style="float:right;margin-top:5px;margin-right:34px"
                  color="red"
                  class="pulsing"
                  :content="notifications.length"
                  :value="notifications.length"
                >
                </v-badge>
                <v-btn to="/notifications" style="float:right" icon
                  ><v-icon>mdi-bell-outline</v-icon></v-btn
                >
              </div>
              <div style="margin-top:30px">
                <div class="scrollmenu mt-5">
                  <div class="card">
                    <v-card
                      class="cardContainer createAccount white--text"
                      width="370"
                      height="190"
                      elevation="6"
                      style="border-radius:12px;padding:35px 40px 35px 40px;text-align:center"
                    >
                    <div style="width:90px" class="top-right">
        <v-select :loading="loading || convertLoading" style="background:white;height:40px" color="black" dense solo :items="currencyTypes"  :item-text="'code'"
                      :item-value="'code'"
                      :value="userData.currency"
                      :label="userData.currency"
                      @change="changeCurrency()" v-model="newCurrency"/>
      </div>
                      <p style="margin:0px;padding:0px;font-size:14px">
                        Wallet Balance
                      </p>
                      <h1
                        v-if="userData.currency!='' && !loading  && !convertLoading"
                        style="margin:5px 0px 5px 0px; font-weight:500;font-size:22px"
                      >
                        <span style="opacity:0.4">{{ userData.currency }}</span>
                        {{
                          parseFloat(
                            parseFloat(walletBalance).toFixed(2)
                          ).toLocaleString("en")
                        }}
                      </h1>
                        <p><v-progress-circular class="mx-auto" v-if="loading == true || convertLoading ==true"  indeterminate></v-progress-circular></p>

                        <v-btn @click="deposit=!deposit" class="mt-2 red--text mr-3"><v-icon x-small>mdi-plus</v-icon>Deposit</v-btn>
                      <v-btn outlined @click="withdraw =! withdraw" class="mt-2 white--text">Withdraw</v-btn>
                    </v-card>
                  </div>

                  <div class="card">
                    <v-card
                      class="white--text ml-3"
                      color="black"
                      width="370"
                      elevation="6"
                      height="190"
                      style="border-radius:12px;padding:35px 40px 35px 40px;text-align:center"
                      to="/subscribers"
                    >
                      <p style="margin:0px;padding:0px;font-size:14px">
                        Total Subscribers
                      </p>
                      <h1
                        style="margin:5px 0px 5px 0px; font-weight:500;font-size:22px"
                      >
                        <span 
                        v-if="!loading"
                          ><v-icon color="white" style="opacity:0.7"
                            >mdi-account-group</v-icon
                          ></span
                        >
                        {{
                          mysubscribers
                         
                        }}
                      </h1>
                  <p><v-progress-circular class="mx-auto" v-if="loading == true || convertLoading ==true"  indeterminate></v-progress-circular></p>
                    </v-card>
                  </div>
                </div>

                <v-row>
                  <v-col cols="12" md="6" sm="6" lg="6">
                    <div style="margin-top:30px">
                      <p
                        class="font-weight-medium"
                        style="margin-bottom:0px;padding-bottom:0px;font-weight:600;font-size:15px;text-decoration:none;text-align:start"
                      >
                        Recent Activities
                      </p>
                      <!-- <router-link
              style="text-decoration:none;float:right;color: #1CA08A"
              to="/transactions"
            >
              View all</router-link
            > -->
                    </div>
                    <div style="width:90%;max-width:350px">
                      <v-skeleton-loader
                        v-if="loading"
                        type="list-item-avatar-two-line"
                      ></v-skeleton-loader>
                      <v-skeleton-loader
                        v-if="loading"
                        type="list-item-avatar-two-line"
                      ></v-skeleton-loader>
                      <v-skeleton-loader
                        v-if="loading"
                        type="list-item-avatar-two-line"
                      />
                      <v-skeleton-loader
                        v-if="loading"
                        type="list-item-avatar-two-line"
                      />
                      <v-skeleton-loader
                        v-if="loading"
                        type="list-item-avatar-two-line"
                      />
                      <v-list v-for="(item, i) in recentActivities" :key="i">
                        <v-list-item
                          v-if="item.status != undefined || loading"
                          class="transborders"
                        >
                          <v-list-item-avatar>
                            <v-img :src="item.image"></v-img>
                          </v-list-item-avatar>

                          <v-list-item-content>
                            <span style="font-size:14px;text-align:start">{{
                              item.title
                            }}</span>
                            <span style="font-size:12px;text-align:start">{{
                              item.status
                            }}</span>
                          </v-list-item-content>
                          <v-list-item-content>
                            <span style="font-size:14px;text-align:end"
                              >{{item.currency}} {{
                                parseFloat(
                                  parseFloat(item.amount).toFixed(2)
                                ).toLocaleString("en")
                              }}</span
                            >
                            <span style="font-size:12px;text-align:end">{{
                              item.timestamp
                            }}</span>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </div>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    sm="6"
                    lg="6"
                    style="margin-left:-90px"
                  >
                     <Chart :userData="userData"/>
                    <!-- <v-card
                      color="#0066f5"
                      width="375"
                      height="190"
                      style="border-radius:8px;margin-left:-20px;text-align:center;padding:30px 50px 30px 50px"
                    >
                      <p
                        class="white--text"
                        style="font-size:14px;margin:0px;padding:15px 0px 0px 0px;font-weight:400"
                      >
                        Portfolio Balance
                      </p>
                      <p
                        style="margin:2px 0px 15px 0px;padding:0px;font-size:22px;font-weight:600"
                        class="white--text"
                      >
                        <span style="opacity:0.4">NGN</span>
                        {{ parseFloat(userData.portfolioBalance).toLocaleString("en") }}
                      </p>
                      <v-btn
                        depressed
                        style="font-weight:400"
                        class="blue--text"
                        color="white"
                        to="/portfolio"
                        >View Portfolio</v-btn
                      >
                    </v-card> -->
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-container>
        </v-col>
      </v-row>
    </v-main>

    <!-- Phone view -->
    <v-main class="hidden-lg-and-up pa-3 pt-5">
      <v-container>
        <v-avatar @click.stop="drawer=!drawer">
          <img :src="person.photoURL" alt="" />
        </v-avatar>
        <span
          class="font-weight-bold"
          style="padding-top:0px;text-decoration:none;font-size:20px"
        >
          Hi {{ person.displayName.substr(0,person.displayName.indexOf(' '))}}👋🏾</span
        >
        <v-badge
          small
          overlap
          dot
          style="float:right;margin-top:5px;margin-right:0px"
          color="red"
          class="pulsing"
          :content="notifications.length"
          :value="notifications.length"
        >
        </v-badge>
        <v-btn to="/notifications" small style="float:right" icon
          ><v-icon>mdi-bell-outline</v-icon></v-btn
        >


        <div style="margin-top:20px">
        <v-card :to="`/${username}`" depressed width="100%" height="90px" class="calCardMobile pa-5 white--text" color="#224068" style="text-align:start;border-radius:12px">
        <v-row no-gutters>
        <v-col sm=1 md=1 lg=1>
        <v-avatar>
          <img :src="person.photoURL" alt="" />
        </v-avatar>
        </v-col>
        <v-col sm=10 lg=10 md=10>
        <div style="margin-left:-5px;width:140px">
        <p style="font-size:13px;margin:0px 0px -5px 0px;padding:0px 0px -10px 0px">Customize your page</p>
        <p style="margin-top:5px;font-size:9px;line-height:1.5">🔗 tippings.me/{{username}}</p>
        </div>
        </v-col>
        <v-col sm=1 md=1 lg=1>
        <v-btn x-small fab color="white" style="float:right;opacity:0.8">
        <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
        </v-col>
        </v-row>
        </v-card>
        </div>

        

        <div class="scrollmenu mt-5">
          <div class="card">
            <v-card
              class="cardContainer createAccount white--text"
              width="290"
              height="180"
              elevation="6"
              style="border-radius:12px;padding:35px 40px 35px 40px;text-align:center"
            >

             <div style="width:90px" class="top-right">
        <v-select :loading="loadingData || convertLoading" style="background:white;height:20px" color="black" dense solo :items="currencyTypes"  :item-text="'code'"
                      :item-value="'code'"
                      :value="userData.currency"
                      :label="userData.currency"
                      @change="changeCurrency()" v-model="newCurrency"/>
      </div>
              
              <h1
              v-if="userData.currency!='' && !loadingData  && !convertLoading &&!loading"
                style="margin:30px 0px 5px 0px; font-weight:500;font-size:28px"
              >
                <span style="opacity:0.4">{{userData.currency}}</span>
                {{
                  parseFloat(
                    parseFloat(walletBalance).toFixed(2)
                  ).toLocaleString("en")
                }}
              </h1>
  
       <p> <v-progress-circular class="mx-auto" v-if="loadingData == true || convertLoading ==true || loading == true"  indeterminate></v-progress-circular></p>
               <v-btn small @click="deposit =!deposit" class="red--text mr-3"><v-icon x-small>mdi-plus</v-icon>Deposit</v-btn>
              <v-btn outlined color="white" class="white--text" small @click="withdraw =!withdraw">Withdraw </v-btn>
            </v-card>
          </div>

          <div class="card">
            <v-card
              class="white--text ml-2"
              color="black"
              width="270"
              elevation="6"
              height="180"
              style="border-radius:12px;padding:35px 40px 35px 40px;text-align:center"
              to="/subscribers"
            >
              <p style="margin:0px;padding:0px;font-size:13px">
                Total Subscribers
              </p>
              <h1
               v-if="!loadingData  && !convertLoading &&!loading"
                style="margin:5px 0px 5px 0px; font-weight:500;font-size:30px"
              >
                <span v-if="!loading" style="opacity:0.4"><v-icon color="white">mdi-account-group</v-icon></span>
                 {{
                  parseFloat(
                    parseFloat(mysubscribers).toFixed(2)
                  ).toLocaleString("en")
                }}
              </h1> 
             <p> <v-progress-circular class="mx-auto" v-if="loadingData == true || convertLoading ==true || loading == true"  indeterminate></v-progress-circular></p>

            </v-card>
          </div>
        </div>
        <div style="margin-bottom:70px;margin-left:0px;max-width:740px">
          <div style="margin-top:30px">
            <p
              class="font-weight-medium"
              style="margin-bottom:0px;padding-bottom:0px;font-weight:600;font-size:15px;text-decoration:none;text-align:start"
            >
              Recent Activities
            </p>
            <!-- <router-link
              style="text-decoration:none;float:right;color: #1CA08A"
              to="/transactions"
            >
              View all</router-link
            > -->
          </div>
          <div>
            <v-list v-for="(item, i) in recentActivities" :key="i">
              <v-list-item
                v-if="!loading"
                class="transborders"
              >
                <v-list-item-avatar>
                  <v-img :src="item.image"></v-img>
                </v-list-item-avatar>

                <v-list-item-content>
                  <span
                    style="margin:5px 10px 0px 0px;text-align:start;font-size:13px"
                    >{{ item.title }}</span
                  >
                  <span style="font-size:11px;text-align:start">{{
                    item.status
                  }}</span>
                </v-list-item-content>
                <v-list-item-content>
                  <span style="text-align:end;font-size:13px"
                    >{{item.currency}} {{
                      parseFloat(
                        parseFloat(item.amount).toFixed(2)
                      ).toLocaleString("en")
                    }}</span
                  >
                  <span style="font-size:10px;text-align:end">{{
                    item.timestamp
                  }}</span>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <!-- <div v-if="activities.length == 0" class="text-center" style="margin-bottom:100px">
              <v-icon size="100px">mdi-clipboard-pulse-outline</v-icon>
              <p>No Activities yet</p>
            </div> -->

            <v-skeleton-loader
              v-if="loading"
              type="list-item-avatar-two-line"
            ></v-skeleton-loader>
            <v-skeleton-loader
              v-if="loading"
              type="list-item-avatar-two-line"
            ></v-skeleton-loader>
            <v-skeleton-loader
              v-if="loading"
              type="list-item-avatar-two-line"
            />
            <v-skeleton-loader
              v-if="loading"
              type="list-item-avatar-two-line"
            />
            <v-skeleton-loader
              v-if="loading"
              type="list-item-avatar-two-line"
            />
          </div>
          <Chart :userData="userData"/>
          <div>
          <div style="margin-top:20px">
        <v-card @click="sheet =!sheet" depressed width="100%" height="90px" class="shareCard pa-5 white--text" color="#224068" style="text-align:start;border-radius:12px">
        <v-row no-gutters>
        <v-col sm=11 lg=11 md=11>
        <div style="margin-left:-5px;width:140px">
        <p style="margin:0px 0px -5px 0px;padding:0px 0px -10px 0px">Congratulations!</p>
        <span style="font-size:10px">You can now share your link</span>
        </div>
        </v-col>
        <v-col sm=1 md=1 lg=1>
        <v-btn @click="sheet =!sheet" x-small fab color="#e50914" style="float:right;opacity:0.8">
        <v-icon color="white">mdi-share-variant</v-icon>
        </v-btn>
        </v-col>
        </v-row>
        </v-card>
        </div>
          </div>
        </div>
      </v-container>
    </v-main>
    <BottomMenu class="hidden-lg-and-up" />

    <!-- Withdrawal-->
    <v-dialog persistent max-width="400px" height="480px" v-model="withdraw">
      <Withdraw
        @closeWithdraw="closeWithdraw"
       
      />
    </v-dialog>


    <v-dialog v-model="success" max-width="500">
      <v-card elevation="24" class="createAccount pa-7 text-center">
        <v-icon size="100px" color="white">mdi-check-circle</v-icon>
        <h1
          style="font-size:23px;padding:10px;color:white"
          class="font-weight-black"
        >
          {{ title }}
        </h1>
        <p style="font-size:15px;color:white">{{ message }}</p>
        <v-btn @click="done()" elevation="24"> Ok</v-btn>
      </v-card>
    </v-dialog>

    <v-dialog v-model="error" max-width="500">
      <v-card elevation="24" class="createAccount pa-7 text-center">
        <v-icon size="100px" color="white">mdi-close-circle</v-icon>
        <h1
          style="font-size:23px;padding:10px;color:white"
          class="font-weight-black"
        >
          {{ title }}
        </h1>
        <p style="font-size:15px;color:white">
          {{ message }}
        </p>
        <v-btn @click="error = false" elevation="24"> Close</v-btn>
      </v-card>
    </v-dialog>


    <v-navigation-drawer v-model="drawer" absolute temporary>
      <v-list-item class="mt-4">
        <v-list-item-avatar height="50px" width="50px">
          <v-img :src="person.photoURL"></v-img>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>{{ person.displayName }}</v-list-item-title>
          <v-list-item-subtitle
            ><v-btn
              to="/settings"
              x-small
              color="#e50914"
              class="white--text"
              rounded
              >Edit Profile</v-btn
            >
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense>
        <v-list-item v-for="(item,i) in menu" :key="i" :to="item.link">
          <v-list-item-icon>
            <v-icon color="#e50914">{{ item.icon }} </v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="logOut()">
        <v-list-item-icon>
        <v-icon color="#e50914">mdi-logout</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
        <v-list-item-title>Log out</v-list-item-title>
        </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>



    <!--Share sheet -->

    <v-bottom-sheet style="border-radius: 20px 20px 0px 0px" v-model="sheet">
        <div style="padding:0px 16px 0px 0px" class="d-flex justify-end" >
        <v-btn
          fab
          depressed
          style="margin-left:85%;text-align:end;margin-bottom:10px"
          small
          right
          color="white"
          @click="sheet = !sheet"
          ><v-icon>mdi-close</v-icon>
        </v-btn>
        </div>

        <v-sheet style="border-radius: 20px 20px 0px 0px;padding:10px" height="400px">
          <Share :username="username"/>
        </v-sheet>
      </v-bottom-sheet>


       <v-bottom-sheet style="border-radius: 20px 20px 0px 0px" v-model="deposit">
        <div style="padding:0px 16px 0px 0px" class="d-flex justify-end" >
        <v-btn
          fab
          depressed
          style="margin-left:85%;text-align:end;margin-bottom:10px"
          small
          right
          color="white"
          @click="deposit = !deposit"
          ><v-icon>mdi-close</v-icon>
        </v-btn>
        </div>

        <v-sheet style="border-radius: 40px 40px 0px 0px;padding:10px" height="450px">
          <PaymentMethods @resolving="resolving" :user="user" :userData="userData" :userSlug="userSlug"/>
        </v-sheet>
      </v-bottom-sheet>


      <v-overlay class="mx-auto text-center"  v-if="resolve">
        <v-progress-circular :size="59" indeterminate></v-progress-circular>
        <p>Resolving...</p>
      </v-overlay>




      <!--Set security pin -->
       <v-dialog fullscreen persistent v-model="setPin">
    <v-sheet class="pa-6 pt-16" width="100%" height="110%">
    <div style="width:80%;margin:auto">
    <h2>Set your Security Pin</h2>
    <p> This would be used to authorize your transactions on Tippings.me. Please keep it confidential.<br><br>
    DO NOT USE  <span style="color:red"><b>1234</b></span> AS YOUR PIN!
    </p>
    <v-row class="mt-10">
    <v-col>
    <v-text-field solo ref="one" type="Number" @input="moveToTwo()" v-model="one" @keyup="checkPin()"/>
    </v-col>
     <v-col>
    <v-text-field solo v-model="two" ref="two" type="Number" @input="moveToThree()" @keyup="checkPin()"/>
    </v-col>
     <v-col>
    <v-text-field solo v-model="three" ref="three" type="Number" @input="moveToFour()" @keyup="checkPin()"/>
    </v-col>
     <v-col>
    <v-text-field solo ref="four" v-model="four" type="Number" @keyup="checkPin()"/>
    </v-col>
    </v-row>
     <v-btn @click="setpin()" :loading="btnloading" :disabled="disabled" style="margin-top:30px;border-radius:12px" class="white--text" large block color="red">Set Security Pin</v-btn>
    </div>
    </v-sheet>
    </v-dialog>


  </v-app>
</template>

<script>
import BottomMenu from "@/components/BottomMenu";
import NavMenu from "@/components/NavMenu";
import { mapGetters,mapState } from "vuex";
import Chart from '@/components/Chart'
import Withdraw from '@/components/Withdraw'
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import Share from '@/components/Share'
import db from '@/db'
import { doc, updateDoc,setDoc } from 'firebase/firestore'
import PaymentMethods from "@/components/PaymentMethods"
import axios from "axios"

export default {
  name: "Dashboard",
  components: {
    BottomMenu,
    NavMenu,
    Chart,
    Withdraw,
    Share,
    PaymentMethods
  },

  data() {
    return {
      drawer:false,
      person:"",
      withdraw:false,
      btnloading: false,
      message: "",
      title: "",
      success: "",
      error: "",
      show: false,
      one: "",
      two: "",
      three: "",
      four: "",
      disabled: true,
      sheet:false,
      mysubscribers:"",
      deposit:false,
      userSlug:"",
      resolve:false,
      convertLoading:false,
      loadingData:false,
      menu: [
        { title: "Dashboard", icon: "mdi-chart-bar", link: "/dashboard" },
        { icon:'mdi-heart-pulse', title: 'Share Link',link:'/share' },
      {
        title: "Activity",
        icon: "mdi-heart-circle",
        link: "/activity",
      },
      { title: "Escrow", icon: "mdi-cash", link: "/escrow" },
      { title: "Subscribers", icon: "mdi-account-group", link: "/subscribers" },
       { title: "Newsletters", icon: "mdi-email", link: "/newsletters" },
      { title: "Settings", icon: "mdi-cog", link: "/settings" },
      ],
      currencyTypes:[
               {country:'Nigeria',code:'NGN'},
               {country:'America',code:'USD'},
               {country:'Australia',code:'AUD'},
               {country:'Benin Republic',code:'XOF'},
               {country:'Canada',code:'CAD'},
               {country:'Dubai',code:'AED'},
               {country:'Europe',code:'EUR'},
               {country:'England',code:'GBP'},
               {country:'Ghana',code:'GHS'},
               {country:'Kenya',code:'KES'},
               {country:'Saudi Arabia',code:'SAR'},
               {country:'South Africa',code:'ZAR'},
               {country:'Uganda',code:'UGX'},
                {country:'Egypt',code:'EGP'},
                ],
        newCurrency:"",
    };
  },

  computed: {

    ...mapState({
      loading:"loading",
      userData:"userData",
      walletBalance:"walletBalance",
      activities:"activities",
      bankDetails:"bankDetails",
      subscribers:"subscribers",
      notifications:"notifications",
      username:"username",
      setPin:"setPin",
      securityPin:"securityPin"
    }),
    ...mapGetters({
      user: "user",
    }),

    recentActivities() {
      return this.activities.slice(0,5)
    },
  },


  metaInfo: {
    title: "Dashboard",
    titleTemplate: "%s | Tippings ",
    meta: [
      {
        name: "description",
        content: "Seamlessly get rewarded for your creativity on Tippings",
      },
      {
        property: "og:title",
        content: " Dashboard | Tippings",
      },
      { property: "og:site_name", content: "Tippings" },
      {
        property: "og:description",
        content: "Seamlessly get rewarded for your creativity on Tippings",
      },
      { property: "og:type", content: "profile" },
      {
        property: "og:url",
        content: "https://tippings.me",
      },
      { property: "og:image", content: "" },
    ],
  },

  async created(){
   await this.$store.dispatch('fetchUserData')
   
  },

  mounted(){
    setTimeout(()=>{
     this.mysubscribers = this.subscribers.length
    },3000)
   
  },
  
  
  beforeCreate() {
    this.userSlug = localStorage.getItem("tippingsKey")
   if(localStorage.getItem('tippingsKey') == null){
     const auth = getAuth();
      signOut(auth)
        .then(() => {
          this.$router.push('/login')
        })
        .catch((error) => {
          console.log(error);
        });
   }
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      this.person =  user
      if (!user) {
        this.$router.push("/login");
      }
    });
  },

  methods: {
    resolving(){
      this.resolve = true
    },

    changeCurrency(){
      this.convertLoading = true
      axios({
        method:"POST",
        url:"https://tips-api.herokuapp.com/converter",
        data:{
          "currency":this.userData.currency,
          "newCurrency":this.newCurrency
        }
      }).then((response)=>{
        console.log(response.data)
        const userRef = doc(db,"users",localStorage.getItem("tippingsKey"))
         setDoc(userRef,{
           "rate":response.data,
           "currency":this.newCurrency,
           "wallet":this.walletBalance*response.data
         },
         {merge:true}
         ).then(()=>{
           this.$store.dispatch("fetchUserData")
           this.convertLoading = false
         })
      }).catch((error)=>{
         this.convertLoading = false
        this.$swal({
          title: "Something went wrong",
          text: error.message,
          icon: "error",
          button: "Ok",
        })
      })
    },

    logOut() {
      localStorage.removeItem('tippingsKey')
      const auth = getAuth();
      signOut(auth)
        .then(() => {
          this.$router.push('/login')
        })
        .catch((error) => {
          console.log(error);
        });
    },

    closeWithdraw(){
      this.withdraw =! this.withdraw
    },
    checkPin(){
      if (this.one != "" && this.two != "" && this.three != "" && this.four != ""){
        this.disabled = false
      }
      else{
        this.disabled = true
      }
    },
     moveToTwo(){
      this.$refs.two.focus()
    },
    moveToThree(){
      this.$refs.three.focus()
    },
    moveToFour(){
      this.$refs.four.focus()
    },
    async setpin(){
      this.btnloading = true
      let Pin = this.one + this.two + this.three + this.four
      await updateDoc(doc(db, "users", localStorage.getItem("tippingsKey")), {
        securityPin:parseInt(Pin)
      })
      this.btnloading = false
      this.$swal({
        title:"Security Pin set successfully!",
        text:"Congratulations,You can now perform transactions safely on Tippings",
        icon:"success",
        confirmButtonText:"Ok"
      })
      location.reload()
         
    }
  },
};
</script>

<style scoped>
.cardContainer {
  position: relative;
}
.top-right {
  position: absolute;
  top: 14px;
  right: 16px;
}
div.scrollmenu {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  padding: 0px 0px 30px 10px;
}

div.scrollmenu .card {
  flex: 0 0 auto;
}

.transborders {
  border: solid 0.1em #eef1f1;
  border-radius: 8px;
  height: 69px;
  margin-bottom: 4px;
}

.calCardMobile {
background-color: #990000;
background-image: linear-gradient(147deg, #990000 0%, #ff0000 74%);
}

.shareCard{
background-color: #000000;
background-image: linear-gradient(315deg, #000000 0%, #180808 74%);

}

.pulsing {
  box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.897);
  border-radius: 30px;
  -webkit-animation: pulsing 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  -moz-animation: pulsing 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  -ms-animation: pulsing 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  animation: pulsing 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  transition: all 300ms ease-in-out;
}

@-webkit-keyframes pulsing {
  to {
    box-shadow: 0 0 0 5px rgba(232, 76, 61, 0);
    border-radius: 30px;
  }
}

@-moz-keyframes pulsing {
  to {
    box-shadow: 0 0 0 5px rgba(232, 76, 61, 0);
    border-radius: 30px;
  }
}

@-ms-keyframes pulsing {
  to {
    box-shadow: 0 0 0 5px rgba(232, 76, 61, 0);
    border-radius: 30px;
  }
}

@keyframes pulsing {
  to {
    box-shadow: 0 0 0 5px rgba(232, 76, 61, 0);
    border-radius: 30px;
  }
}

.createAccount {
  background: linear-gradient(180deg, #e50914 0%, #e00000 100%);
}
</style>
